const navigation = [
    {
        id: 'home',
        path: '/',
        displayName: 'Home',
        showInHeader: true,
        showInFooter: false,
        subMenu: []
    },
    {
        id: 'services',
        path: '/services',
        displayName: 'Services',
        showInHeader: true,
        showInFooter: true,
        subMenu: []
    },
    {
        id: 'contact',
        path: '/contact',
        displayName: 'Contact',
        showInHeader: true,
        showInFooter: true,
        subMenu: []
    },
    {
        id: 'PrivacyPolicy',
        path: '/PrivacyPolicy',
        displayName: 'Privacy Policy',
        showInHeader: false,
        showInFooter: true,
        subMenu: []
    }
];

export default navigation;
